import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MenuIcon, XIcon, PhoneIcon } from 'lucide-react';
import { CONTACT, LOGO } from '../data/copy';
import { useLanguage } from '../contexts/LanguageContext';
import { LanguageToggle } from './LanguageToggle';
import { SectionLink } from './SectionLink';
export function Navbar() {
  const {
    t
  } = useLanguage();
  const [open, setOpen] = useState(false);
  return <header className="fixed inset-x-0 top-0 z-40 bg-white" style={{
    boxShadow: '0 2px 8px rgba(0,0,0,0.10)'
  }} data-id="element-172" data-mp="4lztf7vlmowp">
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between gap-6 px-5 lg:px-8" data-id="element-173" data-mp="lppe0rda8kh">
        <Link to="/" className="flex items-center" data-id="element-174" data-mp="ehbahwuhc87m">
          <img src="https://i.imgur.com/Wx3mHZ2.png" alt={LOGO.alt} className="h-16 w-auto object-contain" data-id="element-175" data-mp="9k1kaez9nsiq" />
        </Link>

        <nav aria-label={t.nav.ariaMain} className="hidden items-center gap-8 lg:flex" data-id="element-176" data-mp="1kzqb5hfn5bot">
          {t.nav.links.map(link => <SectionLink key={link.href} hash={link.href} className="whitespace-nowrap text-sm font-semibold text-forest transition-colors duration-150 ease-out hover:text-rust" data-id="element-177" data-mp="9nfx4j1zn6tf">
              {link.label}
            </SectionLink>)}
        </nav>

        <div className="hidden items-center gap-4 lg:flex" data-id="element-178" data-mp="okfegymn6e13">
          <a href={CONTACT.phoneHref} className="flex items-center gap-2 whitespace-nowrap text-sm font-bold text-forest transition-colors duration-150 ease-out hover:text-rust" data-id="element-179" data-mp="3n3ma4ooncyg4">
            <PhoneIcon className="h-4 w-4 text-forest" aria-hidden="true" data-id="element-180" data-mp="vw32a8apl4s" />
            {CONTACT.phone}
          </a>
          <LanguageToggle data-id="element-181" data-mp="5nnxivukob07" />
          <SectionLink hash="#contact" className="whitespace-nowrap rounded-md bg-rust px-5 py-3 text-sm font-bold text-white transition-colors duration-150 ease-out hover:bg-rust-dark" data-id="element-182" data-mp="5oz0itg71eq9">
            {t.nav.cta}
          </SectionLink>
        </div>

        <div className="flex items-center gap-3 lg:hidden" data-id="element-183" data-mp="319p0aszt5l56">
          <LanguageToggle data-id="element-184" data-mp="2wcq7qevslm93" />
          <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-label={open ? t.nav.closeMenu : t.nav.openMenu} className="rounded-md p-2 text-forest transition-colors duration-150 ease-out hover:bg-forest/5" data-id="element-185" data-mp="2wbf3yf2ckehz">
            {open ? <XIcon className="h-6 w-6" aria-hidden="true" data-id="element-186" data-mp="2ie8mcntd0luc" /> : <MenuIcon className="h-6 w-6" aria-hidden="true" data-id="element-187" data-mp="2df5gx29gwdlu" />}
          </button>
        </div>
      </div>

      {open && <div className="border-t border-neutral-200 bg-white px-5 pb-6 pt-2 lg:hidden" data-id="element-188" data-mp="2nbryni6hyojn">
          <nav aria-label={t.nav.ariaMobile} className="flex flex-col" data-id="element-189" data-mp="7kcgxlb2wdf7">
            {t.nav.links.map(link => <SectionLink key={link.href} hash={link.href} onClick={() => setOpen(false)} className="border-b border-neutral-200 py-3 text-base font-semibold text-forest" data-id="element-190" data-mp="2lsvdm0ed3nd">
                {link.label}
              </SectionLink>)}
          </nav>
          <SectionLink hash="#contact" onClick={() => setOpen(false)} className="mt-5 block rounded-md bg-rust px-5 py-3 text-center text-sm font-bold text-white" data-id="element-191" data-mp="15otch17y3p2">
            {t.nav.cta}
          </SectionLink>
        </div>}
    </header>;
}